<section
	[editableInStoryblok]="_editable"
	data-test-id="searchable-list-section"
>
	<div class="section-spacing">
		<div class="section-inner section-gap">
			<ng-content />
			<sb-columns [colOne]="titleInput()" component="columnOne" />
			@if (!hideFilter()) {
				<div class="flex flex-col gap-4 md:flex-row md:gap-6">
					<div class="w-full justify-start md:w-1/2">
						<vp-label
							[labelText]="
								'compositions.header.search' | translate
							"
							[position]="labelPosition"
							inputName="searchList"
						>
							<vp-input
								[placeholder]="
									'compositions.header.search' | translate
								"
								(emittedValue)="setSearchText($event)"
								icon="assets/icons/icon-looking-glass.svg"
								iconPosition="right"
								inputId="searchList"
								name="searchList"
								type="text"
							/>
						</vp-label>
					</div>
					<div class="w-full justify-end md:w-1/2">
						<vp-label
							[labelText]="'global.sort' | translate"
							[position]="labelPosition"
							inputName="sortList"
						>
							<vp-dropdown
								[centered]="true"
								[placeholder]="'global.sort-by' | translate"
								[selectData]="sortOptions()"
								[value]="'global.sort-by' | translate"
								(selectedValue)="sort($event)"
								data-test-id="sort-options-dropdown"
								inputId="sortList"
								variant="integrated"
							/>
						</vp-label>
					</div>
				</div>
			}
			<ng-container
				[ngTemplateOutlet]="cardList"
				[ngTemplateOutletContext]="{
					items: orderedList(),
					useNgContent: useStoryblokCards(),
				}"
			/>
			@if (persuadeCardItems().length === 0) {
				<ng-container
					[ngTemplateOutlet]="noResults"
					[ngTemplateOutletContext]="{
						title:
							emptyListTitle() ||
								'storyblok.searchable-list.no-items.title'
							| translate,
						content:
							emptyListContent() ||
								'storyblok.searchable-list.no-items.content'
							| translate,
					}"
				/>
			} @else if (orderedList().length === 0) {
				<ng-container
					[ngTemplateOutlet]="noResults"
					[ngTemplateOutletContext]="{
						title:
							'storyblok.searchable-list.no-items-filter.title'
							| translate,
						content:
							'storyblok.searchable-list.no-items-filter.content'
							| translate,
					}"
				/>
			}
		</div>
	</div>
</section>

<ng-template #cardList let-items="items" let-useNgContent="useNgContent">
	@for (item of items; track item.title || item.cardUrl || $index) {
		<vp-persuade-card
			[cardUrl]="item.cardUrl || item.secondaryCtaUrl"
			[content]="useNgContent ? null : item.content"
			[ctaLinkType]="item.ctaLinkType"
			[ctaTarget]="item.ctaTarget"
			[ctaText]="item.ctaText"
			[ctaType]="item.ctaType"
			[ctaUrl]="item.ctaUrl"
			[headingType]="item.headingType"
			[iconColor]="item.iconColor"
			[iconList]="item.iconList"
			[imageRibbon]="item.imageRibbon"
			[images]="item.images || []"
			[isTransparentImage]="item.isTransparentImage"
			[overline]="item.overline"
			[price]="item.price"
			[pricingToolTip]="
				item.pricingToolTip || { occupancy: pricingTooltipOccupancy }
			"
			[secondaryCtaLinkType]="item.secondaryCtaLinkType"
			[secondaryCtaTarget]="item.secondaryCtaTarget"
			[secondaryCtaText]="item.secondaryCtaText"
			[socialProof]="item.socialProof"
			[tags]="item.tags"
			[title]="item.title"
		>
			@if (useNgContent) {
				<ng-container content>
					@for (blok of item.content; track $index) {
						<ndc-dynamic
							[ndcDynamicComponent]="
								components[blok['component']]
							"
							[ndcDynamicInputs]="blok"
							class="hidden"
						/>
					}
				</ng-container>
			}
			@if (disabledText() && item.showDisabledText) {
				<ng-container footerContent>
					<p
						class="mb-0 text-left text-lg italic text-dark-tertiary md:text-right"
						data-test-id="disabled-text"
					>
						{{ disabledText() }}
					</p>
				</ng-container>
			}
		</vp-persuade-card>
	}
</ng-template>

<ng-template #noResults let-content="content" let-title="title">
	<vp-alert [emphasized]="true" [title]="title" type="dialog--warning">
		<sb-richtext
			[content]="content"
			data-test-id="content"
			maxWidth="max-w-full"
		/>
	</vp-alert>
</ng-template>
